module.exports = __webpack_public_path__ + "img/cnydataventures_logo_large.70bf0a57.png";